/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { sendGTMSignInEvent } from '@/data/events/handlers/gtm/SignIn';
import { GTMSignInPayload } from '@/data/types/GTM';

type SignInDelegatorProps = {
	gtm?: GTMSignInPayload;
};

export const signInDelegator = async (payload: SignInDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMSignInEvent(gtm);
	}
};
